import { HttpLink } from '@apollo/client';

const uri = `${import.meta.env.VITE_REACT_APP_API_BASE_URL}/graphql`;

export const httpLink = new HttpLink({
  uri
});
